import "./ButtonHtml.css"

export function ButtonHtml ({value='Valider', onClick, className='info', id=''}) {

  return (
    <button 
      onClick={onClick} 
      className={className}
      id={id}>
      
        {value}
      
    </button>
  );
}